"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCartCB = exports.clearCart = void 0;
var queue_1 = require("./queue");
var get_1 = require("./get");
var events_1 = require("./events");
var jquery_1 = require("../jquery");
var clearCart = function () {
    return new Promise(function (resolve, reject) { return (0, exports.clearCartCB)(resolve, reject); });
};
exports.clearCart = clearCart;
var clearCartCB = function (callback, errorCallback) {
    var o = {
        callback: callback,
        errorCallback: errorCallback,
        url: '/cart/clear.js',
        dataType: 'json',
        method: 'GET',
        data: {},
        action: 'clear'
    };
    o.success = function (data) {
        (0, get_1.setCurrentCart)(data); //The returned value is the full cart, we can use it to update the cart
        if (this.callback)
            this.callback(data);
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_CART_CLEARED, data: data });
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_CART_FETCHED, data: data });
        (0, queue_1.removeTask)(this);
        (0, queue_1.nextTask)();
    }.bind(o);
    o.error = function (e, i, a) {
        if (this.errorCallback)
            this.errorCallback(e ? e.responseJSON || e : "Unknown Error");
        (0, queue_1.removeTask)(this);
        (0, queue_1.errorQueue)();
    }.bind(o);
    o.task = function () {
        jquery_1.jq.ajax(this);
    }.bind(o);
    (0, queue_1.addTask)(o);
};
exports.clearCartCB = clearCartCB;
//# sourceMappingURL=clear.js.map